import { FC, Fragment, Dispatch, SetStateAction, useRef, useEffect, useCallback } from 'react'
import Spiner from "../../../../../../components/form/loading/Spiner";

interface PaginationProps {
    paginator: any;
    setFilters: Dispatch<SetStateAction<Record<string, string | number>>>;
    isLoading: boolean;
    viewName: string;
}

const Pagination: FC<PaginationProps> = ({  paginator, setFilters, isLoading, viewName }) => {
    // Hook para observar cuando el elemento es 100% visible
    const observerRef = useRef<HTMLDivElement | null>(null);

    const handleMoreResults = useCallback(() => {
        // Solo actualiza el page en setFilters, el navigate lo hace el useEffect
        const nextPage = paginator && paginator.page ? Number(paginator.page) + 1 : 2;
        setFilters(prev => ({ ...prev, page: nextPage }));
    }, [paginator, setFilters]);

    const onFullyVisible = useCallback(() => {
        // Solo dispara si hay más páginas
        if (paginator?.hasNextPage) {
            handleMoreResults();
        }
    }, [handleMoreResults, paginator]);

    useEffect(() => {
        if (!observerRef.current) return;
        const observer = new window.IntersectionObserver(
            ([entry]) => {
                if (entry.intersectionRatio === 1) {
                    onFullyVisible();
                }
            },
            { threshold: 1 }
        );
        observer.observe(observerRef.current);
        return () => observer.disconnect();
    }, [onFullyVisible]);

    return (
        <Fragment>
            <div ref={observerRef} id="lazy-observer" className='min-h-10 w-full' >
                {isLoading && <Spiner className={`${viewName === "List" ? "h-12" : "h-48"}`} classSvg={`${viewName === "List" ? "!size-8" : "!size-14"}`} />}
            </div>
        </Fragment>
    )
}

export default Pagination